module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-header pa-0",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "pa-0": "",
      "ma-0": "",
      "xs6": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [(!_vm.showPrevious) ? _c('div') : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-end": "",
      "justify-start": "",
      "row": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPrevious),
      expression: "showPrevious"
    }],
    staticClass: "primary",
    attrs: {
      "flat": "",
      "large": "",
      "sm4": "",
      "xs12": "",
      "disable": _vm.disablePrevious
    },
    on: {
      "click": function($event) {
        return _vm.previousClick()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left"
  }), _vm._v(" "), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("  Voltar")])])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pa-0": "",
      "ma-0": "",
      "xs6": "",
      "sm3": "",
      "md3": "",
      "lg3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-end": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNext),
      expression: "showNext"
    }],
    staticClass: "success",
    attrs: {
      "flat": "",
      "large": "",
      "disabled": _vm.disableNext
    },
    on: {
      "click": function($event) {
        return _vm.nextClick()
      }
    }
  }, [(_vm.confirm) ? [_c('i', {
    staticClass: "fas fa-check"
  }), _vm._v(" "), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("  Confirmar")])] : (_vm.close) ? [_c('i', {
    staticClass: "fas fa-times"
  }), _vm._v(" "), _c('span', {
    staticClass: "mr-2"
  }, [_vm._v("  Fechar")])] : [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v("Avançar")]), _vm._v(" "), _c('i', {
    staticClass: "fas fa-arrow-right"
  })]], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-599441d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/dashboard/matricula_online/NavigationButtons.vue
// module id = 547
// module chunks = 2